import React from 'react';
import { ArrowLeft, HeartHandshake, Map, Store } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './About.css';

const ORIGIN_POINTS = [
  {
    icon: Store,
    title: 'A dor do começo',
    text: 'O CorreFood surgiu ao observar um problema comum em cidades menores: boas lojas locais sem estrutura digital para vender com consistência.',
  },
  {
    icon: Map,
    title: 'A ideia central',
    text: 'Criar uma plataforma simples para conectar cliente, lojista e motoboy com rastreio de entrega e operação regional organizada.',
  },
  {
    icon: HeartHandshake,
    title: 'Nosso compromisso',
    text: 'Fortalecer o comércio local com tecnologia acessível, experiência confiável e suporte próximo para quem compra e para quem vende.',
  },
];

export default function About() {
  const navigate = useNavigate();

  return (
    <div className="about-page">
      <div className="about-container">
        <button type="button" className="about-back-button" onClick={() => navigate(-1)}>
          <ArrowLeft size={16} />
          Voltar
        </button>

        <header className="about-header">
          <h1>Sobre nós</h1>
          <p>
            O CorreFood nasceu para resolver um problema real: aproximar clientes das lojas da região e tornar a
            entrega mais rápida, transparente e justa para todos os envolvidos.
          </p>
        </header>

        <section className="about-story-card" aria-label="Como surgiu o CorreFood">
          <h2>Como surgiu o CorreFood</h2>
          <p>
            Tudo começou com uma percepção simples: muitos estabelecimentos locais tinham produtos excelentes, mas
            perdiam vendas por falta de uma operação digital eficiente. Ao mesmo tempo, clientes queriam praticidade e
            previsibilidade na entrega.
          </p>
          <p>
            A partir disso, construímos o CorreFood para ser uma ponte entre quem vende e quem compra, com foco em
            desempenho local, gestão clara dos pedidos e integração entre lojistas e entregadores.
          </p>
          <p>
            Hoje, seguimos evoluindo com o mesmo propósito: transformar o delivery em uma experiência profissional,
            humana e confiável para cada bairro, cidade e parceiro da plataforma.
          </p>
        </section>

        <section className="about-grid" aria-label="Pilares do CorreFood">
          {ORIGIN_POINTS.map((item) => {
            const Icon = item.icon;
            return (
              <article key={item.title} className="about-item-card">
                <div className="about-item-icon">
                  <Icon size={18} />
                </div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            );
          })}
        </section>
      </div>
    </div>
  );
}
